import { useEffect } from 'react';
import { store } from '../store';
import { navigationRef } from './navigationRef';
import { peekPendingNotificationNav, subscribePendingNotificationNav, type PendingNotificationNav } from './pendingNotificationNav';

export default function usePendingNotificationHandoff(authorized: boolean, locked: boolean, bootstrapping: boolean) {
  useEffect(() => {
    if (!authorized || locked || bootstrapping) return;
    let requested: PendingNotificationNav | null = null;
    const drain = () => {
      const session = store.getState().session;
      if (!session.authorized || session.locked?.show) return;
      const pending = peekPendingNotificationNav();
      if (!pending || requested === pending || !navigationRef.isReady()) return;
      try {
        if (!navigationRef.getRootState()?.routes?.some(route => route.name === 'Main')) return;
        // Plans consumes the intent only once its own navigator is mounted.
        // Keep it queued through sign-in and avoid a recursive state event.
        requested = pending;
        navigationRef.navigate('Main', { screen: 'Plans' });
      } catch {
        requested = null;
      }
    };
    const stopPending = subscribePendingNotificationNav(drain);
    const stopState = navigationRef.addListener('state', drain);
    const stopReady = navigationRef.addListener('ready', drain);
    drain();
    return () => { stopPending(); stopState(); stopReady(); };
  }, [authorized, locked, bootstrapping]);
}
